import styled from "styled-components";

export const ButtonsContainer = styled.div`
  padding-block: 10px;
  display: flex;
  justify-content: center;
  gap: 10px;
`

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const ErrorList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-size: 0.875rem;
  text-align: left;
  padding-inline: 45px;
`

export const ErrorSubTitles = styled.p`
  font-size: 0.875rem;
  font-weight: 600;
  margin:0;

  & > span {
    font-weight: normal;
  }
`
